import React from 'react';

const EditUserSecurity = () => {

    return <div>UserSecurity</div>;
};

export default EditUserSecurity;